import Difference from './Difference.js';
import {compareArray, orderBy} from '../lib/Utils.js';
import {merge, each, difference, includes, find, indexOf, without, map, union, reject,
    isFunction, isObject, isArray, values, bindKey} from "lodash";

// creates a simple model with named sets of records
// records must have unique key
//  - default id, configurable or override getKey()
// listeners can be attached to set by passing a callback function
// listeners fire when the content, order or records in the set change
//  - change is determined using the limited set of compareFields
// call backs are passed Difference object which describes the change to the set
// does not deal with object graphs

export default function Model(name, options)
{
    this.name = name;
    this.key = 'id';
    this.compareFields = ['recordVersion','storeFileVersion','version','lastRenderStatus']; //TBD pare this down
    merge(this, options);
    this.data = {};
    this.sets = {};
    this.listenerCount=0;
    this.setObjectCache = {};
}

//TBD should we look for membership in set when any record changes -
//    - ! yes how else do we know we can remove something
// TBD Do we ever need to know chnages on a single record i.e. we always watch by set not key

//todo proper set objects!!
// - ? throw erroes

Model.prototype =
    {
        // NOTE over ride this for a compound / functional key
        getKey: function(record)
        {
            if (isObject(record) && this.key in record)
                return record[this.key];
        },

        _getKey: function(keyOrRecord) {
            return isObject(keyOrRecord) ? this.getKey(keyOrRecord) : keyOrRecord;
        },

        getVersion: function(keyOrRecord)
        {
            var key = this._getKey(keyOrRecord);
            return key in this.data ? this.data[key].recordVersion :null;
        },

        // Each set has a diff object ,  at the end of any change they are checked and dispacthed if needed
        getSetInfo: function(setName)
        {
            if ( !(setName in this.sets) )
            {
                this.sets[setName] = { order:[], listeners:[], diff: new Difference(this.name, setName) };
            }
            return this.sets[setName];
        },

        newDiff: function(setName)
        {
            var set = this.getSetInfo(setName);
            set.diff = new Difference(this.name, setName, set.order);
            return set.diff;
        },

        addListener: function(setName, changeFunc)
        {
            var listener = {
                callback: changeFunc,
                id: this.name + ':'+setName + ':'+ (++this.listenerCount)
            };
            this.getSetInfo(setName).listeners.push(listener);
            return listener.id;
        },

        removeListener: function(setName,listenerId)
        {
            //flawed ....//var setName = listenerId.split('_')[1];
            //? find index then use splice to remove - could then know if found
            var setInfo = this.getSetInfo(setName);
            setInfo.listeners = reject(setInfo.listeners, {id: listenerId});
        },

        // Create a diff describing the current state i.e. diff from empty
        startDiff: function(setName)
        {
            return new Difference(this.name, setName, [], this.getOrder(setName));
        },

        update: function(setOrRecord)  //mergeOne
        {
            var set = this._makeCollection(setOrRecord);

            each(set, record =>
            {
                if ( this.getKey(record) in this.data)
                {
                    if ( this.store(record) )
                    {
                        this.dispatch();
                    }
                }
                else
                {
                    console.log('Ignoring update for record '+this.getKey(record)+' not in model '+this.name);
                }
            });
        },

        remove: function(keyOrRecord)
        {
            var key = this._getKey(keyOrRecord);

            if ( key in this.data)
            {
                if ( this._delete(key) )
                {
                    this.dispatch();
                    return true;
                }
                return false;
            }
            console.log('Ignoring delete for record '+key+' not in model '+this.name);
            return false;
        },

        //TBD built in sort function ?

        // WArNING removes orphaned records
        replace: function(setName, setOrRecord, order, force) //mergeSet
        {
            var set = this._makeCollection(setOrRecord);
            //TBD check order & set match?
            //Note getSetInfo creates set if doesn't exist
            this.getSetInfo(setName);
            var gotOrder = isArray(order) ;
            var newOrder = gotOrder ? order : [];

            each(set, record =>
            {
                if (! gotOrder ) {
                    newOrder.push(this.getKey(record));
                }
                this.store( record);
            });

            return this._changeSetOrder(setName, newOrder, force);
        },

        setOrder: function(setName, newOrder)  // poke in a pre-made set
        {
            // Todo redo this test - it doesn't work...
            //  - filter(newOrder,  key =>!(key in this.data))
            // todo ? fail if any||all not in data
            each(newOrder, key =>
            {
                if ( !( key in this.data)) {
                    console.log('Ignoring setOrder as '+key+' +not in model '+this.name);
                    return null;
                }
            });

            console.log('setOrder: '+ this.name+ " "+setName+' '+ JSON.stringify(newOrder));
            return this._changeSetOrder(setName,newOrder);
        },

        removeFromSet: function(setName, setOrRecord)
        {
            var set = this._makeCollection(setOrRecord);
            var removeKeys = [];

            each(set, value =>
            {
                removeKeys.push( this._getKey(value));
            });

            var setInfo = this.getSetInfo(setName);
            var currentOrder = setInfo.order;

            return this._changeSetOrder(setName, difference(currentOrder, removeKeys));
        },

        addToSet: function(setName, setOrRecord, unshift)  //add these items into the set if they aren't already
        {
            var set = this._makeCollection(setOrRecord);
            var setInfo = this.getSetInfo(setName);
            var newOrder = setInfo.order ;

            each(set, value =>
            {
                var key = null;
                if ( isObject(value))
                {
                    this.store(value);
                    key = this.getKey(value);
                }
                else if (value in this.data )
                {
                    key = value;
                }

                if (key)
                {
                    if ( !includes(setInfo.order, key) )
                    {
                        if (unshift) {
                            newOrder.unshift(key);
                        } else {
                            newOrder.push(key);
                        }
                    }
                }
                else
                {
                    console.log('Ignoring Add id  - not in model');
                    // TBD - abandon?
                }
            });

            //console.log('addToSet: '+ this.name+ " "+setName+' '+ JSON.stringify(set));
            return this._changeSetOrder(setName,newOrder);
        },

        // deprecated
        _makeCollection: function(set) {
            return this._makeArray(set);
        },

        _makeArray: function(set)
        {
            if (! isArray(set)){
                if (isObject(set) && 'undefined' === typeof this.getKey(set)){
                        // Not a recored for this set
                        set = values(set);
                } else {
                    // assume its a single record
                    set = [ set ];
                }
            }

            return set;
        },


        // NOTE just compares the sets - does not look at records
        // return true if the same
        compareSet: function (arrayA, arrayB)
        {
            return compareArray(arrayA, arrayB, true);
        },

        // This is based on the code used for storage - isCurrent
        // true - equivalent
        compareRecord: function compareRecord(recordA, recordB)
        {
            // Related to offline sync code - can probably remove
            //if ((recordA._changed || 0) !== (recordB._changed || 0))
            //return false;

            // if its in the new record,  it must match in the old one
            var foundMismatch = find(this.compareFields, function(field)
            {
                return ( field in recordB ) &&
                    !(field in recordA && recordA[field] === recordB[field]);
            });
            return foundMismatch === undefined ;
        },

        // **** Changing this to ALWAYS store data as sub records may have changed
        // Even if the primary hasn't
        // Events still dispatched base on compare
        // Need to get clever about having a combined data tree - not just separate sets
        // What does backbone do out of the box?

        store: function (record)
        {
            if (! isObject(record) ) return false;
            var key = this.getKey(record);

            if (key===null || key===undefined) return false;  // Is this ok without 0
            var changed = true;  //add

            if (key in this.data)
            {
                changed = ! this.compareRecord(this.data[key], record) ;

                if (changed)
                {
                    each(this.sets,(setInfo,setName)=>
                    {
                        if ( indexOf(setInfo.order, key) !== -1)
                        {
                            setInfo.diff.addChanged(key);
                        }
                    });
                }

                this.updateRecord(record, key, changed);
            }
            else
            {
                this.addRecord(record, key);
            }

            return changed;
        },

        // allow control over how a record is placed in the model
        addRecord: function(record, key)
        {
            this.data[key] = this.cloneOnStore ?
                ( isFunction(record.clone) ? record.clone() :merge({},record)) :
                record;
        },

        // allow control over how a record is replaced in the model
        // Default Merge in 'equal' records to pick up expanded attributes on full views
        updateRecord: function(record, key, changed)
        {
            // todo ?should be able to update if its not there already
            if (changed || !(key in this.data)) {
                this.addRecord(record, key);
            } else {
                var oldRecord = this.data[key];
                this.data[key] = isFunction(oldRecord.merge) ?
                    oldRecord.merge(record) :  //Note could return new object
                    merge(oldRecord, record);
            }
        },

        _delete: function(keyOrRecord)
        {
            var key = this._getKey(keyOrRecord);
            var changed = false;

            if (key in this.data)
            {
                each(this.sets,(set,setName)=>
                {
                    if (indexOf(set.order, key) !== -1)
                    {
                        set.order = without(set.order, key);
                        set.diff.setNewOrder(set.order);
                    }
                });
                changed = true;
                delete this.data[key] ;
            }

            return changed;
        },

        //WARNING - this will remove data not in any set
        _changeSetOrder: function _changeSetOrder(setName, setOrder, force)
        {
            var set = this.getSetInfo(setName);
            set.order = setOrder;
            set.diff.setNewOrder(setOrder);
            var changed = set.diff.isAnythingChanged();

            if (changed)
            {
                var allUsedKeys = union.apply([],map(this.sets,'order'));
                each( difference(set.diff.getRemoved(), allUsedKeys), key=>
                {
                    //unused
                    delete this.data[key] ;
                });
            }

            this.dispatch(force && setName);
            return changed;
        },

        // deprecated - confusing
        storeSet: function storeSet(setName, setOrder, force) {
            return this._changeSetOrder(setName, setOrder, force);
        },

        dispatch: function(forceSetName)
        {
            each( this.sets, (set, setName)=>
            {
                this.dispatchSet(setName,setName===forceSetName);
            });
        },

        dispatchSet: function(setName, force)
        {
            if ( !(setName in this.sets) )
                return;

            var set = this.sets[setName];

            if (force || set.diff.isAnythingChanged())
            {
                var oldDiff = set.diff ;
                oldDiff.force = !!force;
                this.newDiff(setName);
                //var self = this;

                each(set.listeners, listener =>
                {
                    setTimeout( function()
                    {
                        //console.log('Dispatching: '+ self.name+' '+setName);
                        console.log('Dispatching: '+ listener.id);
                        listener.callback(oldDiff);
                    }, 0);
                });
            }
        },

        isInAnySet: function(keyOrRecord,except)
        {
            var key = this._getKey(keyOrRecord);
            each(this.sets,(setInfo,setName)=>
            {
                if ( (except !== setName) && indexOf(setInfo.order, key) !== -1)
                {
                    return true;
                }
            });
            return false;
        },

        exists: function(keyOrRecord) {
            return this._getKey(keyOrRecord) in this.data;
        },

        get: function(keyOrRecord) {
            var key = this._getKey(keyOrRecord);
            return key in this.data ? this.data[key] : null;
        },

        getOrder: function(setName) {
            return setName in this.sets ? this.sets[setName].order : [] ;
        },

        getSet: function(setName)
        {
            return setName in this.sets ? orderBy(this.data, this.sets[setName].order) : [];
        },

        getAll: function()
        {
            return values(this.data);
        },

        getSetLength: function(setName){
            return setName in this.sets ? this.sets[setName].order.length : 0 ;
        },

        //TBD blatt all sets orders
        empty: function ()
        {
            each(this.sets, (set, setName) =>
            {
                //set.order = [];   // NOTE: retain listeners
                //set.diff = new Difference(this.name, setName, set.order);
                this._changeSetOrder(setName,[]);
            });
            this.data = [];
        },


        // Helper functions for single item sets (used to be context)

        getId: function getId(setName)  // getFirstId
        {
            var order = this.getOrder(setName);
            return (order !== null && order.length > 0) ? order[0] : null;
        },

        setId: function setId(setName, id)  //setFirstId
        {
            return this.setOrder(setName, id ? [id] : []) ;
        },

        getOne: function getOne(setName)
        {
            var id = this.getId(setName);
            return (id !== null) ? this.get(id) : null;
        },

        replaceOne: function replaceOne(setName, obj)
        {
            return this.replace(setName, obj ? [obj] : []);
        },


        // Helper object to operate on a specific set
        // todo not convinced this is the best approach but working...

        getSetObject: function (setName) {
            if (!(setName in this.setObjectCache)) {
                this.setObjectCache[setName] = {
                    remove: bindKey(this, 'removeFromSet', setName),
                    add: bindKey(this, 'addToSet', setName),
                    changeOrder: bindKey(this, 'setOrder', setName),
                    replace: bindKey(this, 'replace', setName),
                    getLength: bindKey(this, 'getSetLength', setName),
                    getInfo: bindKey(this, 'getSetInfo', setName),
                    getOrder: bindKey(this, 'getOrder', setName),
                    get: bindKey(this, 'getSet',  setName),
                    replaceOne: bindKey(this, 'replaceOne', setName),
                    getOne: bindKey(this, 'getOne', setName),
                    update: bindKey(this, 'update') //todo set ?specific update
                };
            }
            return  this.setObjectCache[setName];
        },

        getItemObject: function (setName) {
            if (!(setName in this.setObjectCache)) {
                this.setObjectCache[setName] = {
                    replace: bindKey(this, 'replaceOne',  setName),
                    getInfo: bindKey(this, 'getSetInfo', setName),
                    get: bindKey(this, 'getOne', setName),
                    update: bindKey(this, 'update')  //todo set ?specific update
                };
            }
            return  this.setObjectCache[setName];
        }
    };